import { get, post } from "@/utils/http";

let baseURL = "/sealApply";

// 签章完成后修改申请状态
const modifyInfo = data => get(`${baseURL}/modify`,data);

// API
export default {
    modifyInfo
}